import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { ArrowLeft } from "lucide-react";

export default function FreightIQ() {
  return (
    <>
      <SEO
        title="FreightIQ™ | Carrier Coordination Workspace | DeMaxtore"
        description="FreightIQ™ is the carrier coordination Workspace Product inside DeMaxtore. Product page coming soon."
        canonical="/freightiq"
      />
      <main className="flex min-h-screen items-center justify-center bg-white px-6">
        <div className="max-w-lg text-center">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-blue-brand">Workspace Product</p>
          <h1 className="mt-4 text-4xl font-semibold text-navy sm:text-5xl">FreightIQ™</h1>
          <p className="mt-4 text-[15px] leading-relaxed text-slate-600">
            The FreightIQ™ product page is coming soon. In the meantime, learn more about the platform on the Carrier Coordination overview.
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to="/carrier-coordination"
              className="inline-flex items-center gap-2 rounded-full border border-slate-line bg-white px-5 py-3 text-sm font-medium text-navy shadow-sm transition hover:border-slate-300 hover:shadow-card"
            >
              <ArrowLeft className="h-4 w-4" />
              Back to Carrier Coordination
            </Link>
            <Link
              to="/workspace"
              className="inline-flex items-center gap-2 rounded-full bg-blue-brand px-5 py-3 text-sm font-medium text-white shadow-card transition hover:shadow-card-lg"
              style={{ backgroundColor: "hsl(var(--blue))" }}
            >
              Create Your Free Workspace
            </Link>
          </div>
        </div>
      </main>
    </>
  );
}
